// import Vue from 'vue'
import axios from 'axios'
import Router from './../router'

const modules = {
  // 多个请求同时进行
  allAxios: function (obj) {
    let arrs = []
    Object.keys(obj).forEach((key) => {
      arrs.push(obj[key])
    })
    return axios.all(arrs)
  }
}

// 请求拦截器 例
axios.interceptors.request.use(
  config => {
    let a = JSON.parse(sessionStorage.getItem('dtFromData'))
    if (a) { // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers = {
        'app-token': a.accessToken
      }
    }
    let user = JSON.parse(window.localStorage.getItem('accountInfo'));
    if (user.token !== '' || user.token !== undefined || user.token !== null) { // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers = {
        Authorization: 'Bearer ' + user.token
      }
    }
    if (config.data == undefined || config.data == null || !config.data) {
      if (window.localStorage.getItem('web_userId')) {
        config.data = {
          accountId: Number(window.localStorage.getItem('web_userId'))
        }
      } else {
        config.data = {
          accountId: user.AID
        }
      }
    } else {
      if (window.localStorage.getItem('web_userId')) {
        config.data.accountId = Number(window.localStorage.getItem('web_userId'))
      } else {
        config.data.accountId = user.AID
      }
    }
    // 对课程列表接口查询添加排除过期约课课程（由于页面使用该接口情况较多，统一处理下，当出现type加is_show一起使用时则是查找约课未过期列表，不需要添加exclude_expire_appoint）
    // let urls = config.url
    // if (urls.indexOf('v1') !== -1) {
    //   let params = config.params
    //   if (urls.split('v1')[1] === '/course/get-list') {
    //     if (params.type !== undefined && params.is_show !== undefined) {
    //     } else {
    //       config.params.exclude_expire_appoint = 1
    //     }
    //   }
    // }
    return config
  },
  err => {
    console.error({
      title: '重新登录',
      message: '重新登录'
    })
    return Promise.reject(err)
  }
)

// 响应拦截器
axios.interceptors.response.use(
  function (response) {
    // let code = response.data.code
    // if (code === 20000 || code === '20000') {
    //   let aurl = response.config.url.split('investor-education-manager/')[1]
    //   let aname = aurl.split('?')[0]
    //   if (aname !== 'app-api/v1/common/collect' || aname !== 'api/v1/common/collect') {
    //     Vue.$vux.toast.show({
    //       text: response.data.msg,
    //       onHide () {
    //         console.log('20000')
    //         window.location.reload(true)
    //       }
    //     })
    //   }
    // }
    // if (code === 500 || code === '500') {
    //   Router.push({
    //     name: 'error.error500'
    //   })
    // }
    // if (code === 404 || code === '404') {
    //   Router.push({
    //     name: 'error.error404'
    //   })
    // }
    // 对响应数据做点什么
    return Promise.resolve(response)
  },
  function (error) {
    // beacon.refreshToken({},function(){})
    // beacon.getAccountInfo({},function (accountInfo) {
    //     window.localStorage.setItem('user', JSON.stringify(accountInfo));
    // })
    // 错误跳转500路由
    /*Router.push({
      name: 'error.error500'
    })*/
    // 对响应错误做点什么
    // console.error({title: '网络请求错误', message: error.response.data.msg})
    return Promise.reject(error)
  }
)

// 合并目录下的所有文件除去index,resource,api
const files = require.context('.', false, /\.js$/)
files.keys().forEach((key) => {
  if (key === './index.js' || key === './resource.js' || key === './api.js') return
  modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default
})

export default modules



// WEBPACK FOOTER //
// ./src/fetch/api.js